import { differenceInDays, clamp } from "date-fns";

export const getTimeProgressPercentage = (from: Date, to: Date, current: Date): number => {
    if (to < from) {
        return 0;
    }

    const clampedCurrent = clamp(current, { start: from, end: to });

    const totalDuration = differenceInDays(to, from);
    const elapsedDays = differenceInDays(clampedCurrent, from);

    return Math.round((elapsedDays / totalDuration) * 100);
};
